import { defineComponent as _defineComponent } from 'vue'
import IconMaterial from '@design_system_v3/components/atoms/IconMaterial.vue';
import Avatar from '@design_system_v3/components/atoms/Avatar.vue';
import { computed } from 'vue';

export type Variant = 'primary' | 'secondary' | 'tertiary' | 'success' | 'error' | 'warning';

interface ChipProps {
  text?: string;
  size?: 'sm' | 'md';
  variant?: Variant;
  tone?: 'light' | 'dark';
  avatarImageUrl?: string;
  avatar?: boolean;
  iconLeft?: string;
  iconLeftVariant?: string;
  iconRight?: string;
  iconRightVariant?: string;
  disabled?: boolean;
  close?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ChipTagV2',
  props: {
    text: { type: String, required: false },
    size: { type: String, required: false, default: 'sm' },
    variant: { type: String, required: false, default: 'primary' },
    tone: { type: String, required: false, default: 'light' },
    avatarImageUrl: { type: String, required: false },
    avatar: { type: Boolean, required: false },
    iconLeft: { type: String, required: false },
    iconLeftVariant: { type: String, required: false },
    iconRight: { type: String, required: false },
    iconRightVariant: { type: String, required: false },
    disabled: { type: Boolean, required: false, default: false },
    close: { type: Boolean, required: false }
  },
  emits: ['click', 'close'],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const chipClasses = computed(() => {
  return `iconn_chip--${props.disabled ? 'disabled' : props.variant}-${props.tone} iconn_chip--${props.size} `;
});

const iconColor = computed(() => {
  if (props.tone === 'light') {
    if (props.disabled) return '#6F747C';
    if (props.variant === 'primary') return '#602773';
    if (props.variant === 'secondary') return '#2B3F7B';
    if (props.variant === 'tertiary') return '#334155';
    if (props.variant === 'success') return '#0D5947';
    if (props.variant === 'error') return '#962B3F';
    if (props.variant === 'warning') return '#845A09';
  }

  if (props.tone === 'dark') {
    if (props.disabled) return '#6F747C';
    return '#ffffff';
  }
  return '';
});

const iconSize = computed(() => {
  if (props.size === 'sm') return 16;
  if (props.size === 'md') return 20;
  return 16;
});

const emit = __emit;

const handleClick = (event: MouseEvent) => {
  if (!props.disabled) {
    emit('click', event);
  }
};

const handleClose = () => {
  emit('close');
};

const __returned__ = { props, chipClasses, iconColor, iconSize, emit, handleClick, handleClose, IconMaterial, Avatar }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})